import { render, staticRenderFns } from "./BriefsView.vue?vue&type=template&id=64262676&scoped=true"
import script from "./BriefsView.vue?vue&type=script&lang=js"
export * from "./BriefsView.vue?vue&type=script&lang=js"
import style0 from "./BriefsView.vue?vue&type=style&index=0&id=64262676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64262676",
  null
  
)

export default component.exports